export const PERISCOPE_PROFILES_COPY = {
	EDIT_ACCESS: 'Edit Access',
	READ_ACCESS: 'Read Access'
};
